export default "__VITE_ASSET__AGxkhx3B__"